import { useEffect, useMemo, useRef, useCallback, useState } from "react";
import * as THREE from "three";
import { useMapStore } from "../../store/useMapStore.js";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { useEntityStore } from "../../store/useExportStore.js";
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { geometryToJSON, CreateShapegeometry, CreateShapegeometryxyz,CreateShapegeometryWithMultipleVoids, CreateShapegeometryWithMultipleVoidsxyz} from "../../utils/GeometryHelper.js";
import GUI from "lil-gui";
import { Stage, GeometryType } from "../../constants/progress.js";
import { useProgressStore } from "../../store/progressStore.js";
import { useGeometrySelectionStore } from "../../store/useGeometrySelectionStore.js";

const RiskGebietGeometry = ({ 
  entities, 
  selectedEntityId, 
  setSelectedEntityId,
  inputColor,
  inputVisibilty,
  onEntitySelect,
  className,
  crs,
  geometryType
  }) => {
  const updateProgress = useProgressStore.getState().updateProgress;
  const meshRef = useRef();
  const [siteColor, setsiteColor] = useState("#9edcf5");
  const { selectParcel, isParcelSelected, selectedType } = useGeometrySelectionStore();
 
  
  const { mergedGeometry, mergedEdgesGeometry, entityIndices, vertexToEntity, sites } = useMemo(() => {
    const geometries = [];
    const edgeGeometries = [];
    const indices = [];
    const vertexIndices = [];
    const sites = [];
    updateProgress(geometryType,{
      stage: Stage.CREATE,
      message:'Create geometries',
      progress: 75,
      error: null
     
    });

    entities.forEach((entity, entityIndex) => {
      const extcoords = entity.exteriorring;
      const intcoords = entity.interiorring;
      let coords;
      console.log("Risk area exterior coordinates", extcoords)
      console.log("Risk area exterior coordinates", intcoords)
      const geometry = CreateSurface(extcoords,intcoords, entity);
      if (geometry) {
        const triangleCount = geometry.index ? 
        geometry.index.count / 3 : 
        geometry.attributes.position.count / 3;
        for (let i = 0; i < triangleCount; i++) {
          indices.push(entityIndex);
        }
        
        // Map each vertex to entity
        const vertexCount = geometry.attributes.position.count;
        for (let i = 0; i < vertexCount; i++) {
          vertexIndices.push(entityIndex);
        }
       
        geometries.push(geometry);
        edgeGeometries.push(new THREE.EdgesGeometry(geometry));
      }
     
    });
    
    let mergedGeometry, mergedEdgesGeometry;
    if (geometries.length > 0) {
      updateProgress(geometryType,{
      stage: Stage.DONE,
      message:'Create geometries completed',
      created: geometries.length,
      progress: 100,
      error: null
     
    });
     console.log("Created risk geometries: ", geometries)

      mergedGeometry = BufferGeometryUtils.mergeGeometries(geometries, false);
      mergedEdgesGeometry = BufferGeometryUtils.mergeGeometries(edgeGeometries, false);
      console.log("Merged Risk area geometry: ", mergedGeometry)
      
      // Initialize vertex colors with base color
      const positionCount = mergedGeometry.attributes.position.count;
      const colors = new Float32Array(positionCount * 3);
      const baseColor = new THREE.Color(inputColor);
      
      for (let i = 0; i < positionCount; i++) {
        colors[i * 3] = baseColor.r;
        colors[i * 3 + 1] = baseColor.g;
        colors[i * 3 + 2] = baseColor.b;
      }
      
      mergedGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
    } else {
      updateProgress(geometryType,{
      stage: Stage.ERROR,
      message:'Failed to create geometries',
      error:"Error creating geometries"
     
    });
      console.log("No geometries found/creating geometries failed!");
    }
    
    return { mergedGeometry, mergedEdgesGeometry, entityIndices: indices, vertexToEntity: vertexIndices, sites };
  }, [inputVisibilty, entities, crs]); 

  // Reset colors when selection is cleared (background or other geometry clicked)
  useEffect(() => {
    if (!mergedGeometry || !mergedGeometry.attributes.color) return;
    
    // If no parcel is selected (background clicked or other geometry selected)
    if (selectedType !== 'parcel') {
      const positionCount = mergedGeometry.attributes.position.count;
      const colors = mergedGeometry.attributes.color.array;
      const baseColor = new THREE.Color(siteColor);
      
      // Reset all vertices to base color
      for (let i = 0; i < positionCount; i++) {
        colors[i * 3] = baseColor.r;
        colors[i * 3 + 1] = baseColor.g;
        colors[i * 3 + 2] = baseColor.b;
      }
      
      mergedGeometry.attributes.color.needsUpdate = true;
      setSelectedEntityId(null);
    }
    // If a different parcel is selected, check if our current selection needs to be cleared
    else if (selectedEntityId && !isParcelSelected(selectedEntityId)) {
      const positionCount = mergedGeometry.attributes.position.count;
      const colors = mergedGeometry.attributes.color.array;
      const baseColor = new THREE.Color(siteColor);
      
      // Reset all vertices to base color
      for (let i = 0; i < positionCount; i++) {
        colors[i * 3] = baseColor.r;
        colors[i * 3 + 1] = baseColor.g;
        colors[i * 3 + 2] = baseColor.b;
      }
      
      mergedGeometry.attributes.color.needsUpdate = true;
      setSelectedEntityId(null);
    }
  }, [selectedType, selectedEntityId, isParcelSelected, mergedGeometry, siteColor, setSelectedEntityId]);



  // useEffect(() => {
  //   const params = { siteColor: "#f1e9e9" };
  //   const gui = new GUI();

  //   const siteFolder = gui.addFolder("Site Surface");
    
  //   siteFolder
  //     .addColor(params, "siteColor")
  //     .name("Color")
  //     .onChange((value) => {
  //       setsiteColor(value);
  //       const color = new THREE.Color(value);
  //       const r = Math.round(color.r * 255);
  //       const g = Math.round(color.g * 255);
  //       const b = Math.round(color.b * 255);
  //       console.log(`Site RGB: (${r}, ${g}, ${b})`);
  //     });
    
  //   siteFolder.open();
  //   const guidom = gui.domElement;
  //   guidom.style.right = "100px";
  //   guidom.style.top = "140px";
    
  //   return () => gui.destroy(); 
  // }, [inputVisibilty]);

  const handleClick = useCallback((event) => {
  if (!meshRef.current) {
    console.log('No mesh ref');
    return;
  }
  if (!inputVisibilty) {
    console.log('Layer not visible, ignoring click');
    return;
  }
  
  const intersects = event.intersections;
  
  if (intersects && intersects.length > 0) {
    const intersection = intersects[0];
    const faceIndex = intersection.faceIndex;
    
    if (faceIndex !== undefined && entityIndices[faceIndex] !== undefined) {
      const selectedEntityIndex = entityIndices[faceIndex];
      const selectedEntity = entities[selectedEntityIndex];
      
      if (selectedEntity && selectedEntity.Name === className) {
        console.log("Selected entity: ", selectedEntity);
        
        // Stop propagation first to prevent interference
        event.stopPropagation();
        
        // Update selection state
        selectParcel(selectedEntity.id);
        setSelectedEntityId(selectedEntity.id);
        
        // Call onEntitySelect to update the store
        if (onEntitySelect) {
          console.log("Calling onEntitySelect with:", selectedEntity); // Debug log
          onEntitySelect(selectedEntity);
        }
        
        // Update vertex colors AFTER selection
        if (mergedGeometry && mergedGeometry.attributes.color) {
          const positionCount = mergedGeometry.attributes.position.count;
          const colors = mergedGeometry.attributes.color.array;
          const baseColor = new THREE.Color(siteColor);
          const selectedColor = new THREE.Color('#2B323A');
         
          for (let i = 0; i < positionCount; i++) {
            const vertexEntityIndex = vertexToEntity[i];
            const isSelected = vertexEntityIndex === selectedEntityIndex;
            const color = isSelected ? selectedColor : baseColor;
            
            colors[i * 3] = color.r;
            colors[i * 3 + 1] = color.g;
            colors[i * 3 + 2] = color.b;
          }    
          mergedGeometry.attributes.color.needsUpdate = true;
        }
      }
    }
  }
}, [entities, entityIndices, vertexToEntity, onEntitySelect, inputVisibilty, className, mergedGeometry, siteColor, setSelectedEntityId, selectParcel]);
  if (!mergedGeometry) return null;

  return (
    <group visible={inputVisibilty} position={[0,5, 0]} >
      {inputVisibilty && (
        <mesh
          ref={meshRef} 
          geometry={mergedGeometry} 
          onClick={handleClick}
          polygonOffset
          polygonOffsetFactor={1.5}
          polygonOffsetUnits={1.5}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            transparent={false}


          />
        </mesh>
      )}
      
      {/* Black outline */}
      {mergedEdgesGeometry && (
        <lineSegments geometry={mergedEdgesGeometry} position={[0, 0.5, 0]}>
          <lineBasicMaterial color="black" />
        </lineSegments>
      )}
    </group>
  );
};

export default RiskGebietGeometry;

// Helper functions below...




function CreateSurface(extring,intring, entity) {
  if (!extring || extring.length === 0) {
    console.warn("Empty coordinates provided");
    return null;
  }
  let geometry;
  let sclicedIntRing;
  const slicedExtRing = extring.slice(0, -1);
  console.log("Sliced Rings: ", slicedExtRing[0].x)
  
  if(intring!= "")
  {
     sclicedIntRing = intring.slice(0,-1);
  }
  geometry = CreateShapegeometryWithMultipleVoidsxyz(slicedExtRing,sclicedIntRing);


  
  
  // if(coordinates.length == 2)
  // {
  //   console.log(coordinates)
  //   let mainring;
  //   let holes = [];
    
  //   coordinates.forEach((coords, index) => {
  //     if (index === 0) {
        
  //       mainring = coords.slice(0, -1);
      
        
  //     } else {
  //       holes.push(coords.slice(0, -1));}
  //   });

  //   if (mainring && holes.length > 0) {
  //     console.log("Mainring: ", mainring, "Holes: ", holes)
  //     console.log("CREATING MULTI POLYGONS", mainring)
  //     const multigeometry = CreateShapegeometryWithMultipleVoids(mainring, holes);
  //     console.log("Multi geometry: ",  multigeometry)
  //     return multigeometry;
  //   }
   
   
  // }

  return geometry;
}




